import { render, staticRenderFns } from "./quiz_take.vue?vue&type=template&id=0bdbe8d5&"
import script from "./quiz_take.vue?vue&type=script&lang=js&"
export * from "./quiz_take.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports